import { QueryObserverOptions } from 'react-query';

import { makeResourceKeys } from 'requests/resources/makeResources/makeResourcesKeys';
import { useEntityMany } from 'requests/resources/makeResources/queries';
import { Params } from 'requests/resources/makeResources/types';

import { PatientFormTemplate } from '../types';

export const keys = makeResourceKeys('patientFormTemplates');

type TQueryData = PatientFormTemplate[];

export default function usePatientFormTemplateMany(params: Params = {}, options?: QueryObserverOptions<TQueryData>) {
  const userQuery = useEntityMany<TQueryData>(keys.many, '/crudList', params, options);
  return userQuery;
}
